/*=========================================================================================
  File Name: moduleCompanyActions.js
  Description: Company Module Actions
==========================================================================================*/

export default {
    updateUserVenue({ commit }, payload) {
      new Promise ((resolve, reject) => {
        commit('UPDATE_USER_VENUE', payload)
        resolve()
      })
    },
}
